<template>
  <q-list
    :class="[sectionData.class]"
    v-if="sectionData.list !== undefined"
    :separator="sectionData.separator"
  >
    <q-separator v-if="sectionData.separator" />
    <q-item
      class="full-width justify-between items-stretch"
      v-for="(listItem, index) in sectionData.list"
      :key="index"
    >
      <div class="row items-center justify-start" :class="listItem.label.class">
        <q-item-label v-html="listItem.label.text" />
      </div>
      <div class="row items-center justify-start">
        <q-item-label
          style="word-break: break-word"
          :class="listItem.value.class"
          v-html="listItem.value.text"
        />
      </div>
    </q-item>
    <q-separator v-if="sectionData.separator" />
  </q-list>
</template>
<script>
export default {
  name: "DList",
  props: {
    sectionData: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
